<template>
<ContenedorCampos :titulo="titulo" :isObligatorio="Obligatorio" :error="error">
  <v-radio-group :disabled="bDeshabilitado" v-model="selectValue" hide-details>
    <v-radio
      v-for="(info, key) in aOptions"
      :key="key"
      :label="info.DatoMostrar"
      :value="info.ID"
      hide-details
    ></v-radio>
  </v-radio-group>
</ContenedorCampos>
</template>
<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js' 

export default {
  name: 'RadioButton',
  mixins: [ DinamicosMixin ],
  components: {
    ContenedorCampos,
  },
  data () {
    return {
      radioGroup: 1,
    }
  },
  async mounted () {
    await this.CargarData()

  },
  methods: {
    // async CargarData(){
    //   let aRespuesta = []
    //   let nPagina = 1
    //   let nTotalPaginas = 1
    //   let axiosPreguntasvalor
    //   this.nCargando = true

    //   while (nPagina <= nTotalPaginas) {
    //     axiosPreguntasvalor = await axiosServices.getConfiguration('/formularios-dinamicos/preguntas/valores', true, `app=WEBGesDoc&pagina=${nPagina}&tabla=${this.aData}`)
    //     aRespuesta.push(axiosPreguntasvalor.aData.aData)
    //     nTotalPaginas = parseInt(axiosPreguntasvalor.aData.nPagina)
    //     nPagina++
    //   } 
      
    //    this.aOptions = aRespuesta.flat()
    //    this.nCargando = false
    // },
  },
  computed: {
    
  },

}
</script>

<style lang="scss" scoped>

</style>
